import { render, staticRenderFns } from "./importResume.vue?vue&type=template&id=130cee57&scoped=true"
import script from "./importResume.vue?vue&type=script&lang=js"
export * from "./importResume.vue?vue&type=script&lang=js"
import style0 from "./importResume.vue?vue&type=style&index=0&id=130cee57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130cee57",
  null
  
)

export default component.exports